// Subscriber search + autocomplete.
//   GET /v1/api/search?q=…   — full lookup (session + ONU); 404 → no match
//   GET /v1/api/suggest?q=…  — lightweight autocomplete rows
//
// The Go side returns 404 with {ok:false, error:"No session found …"}
// when there's no match; ApiClient turns that into an ApiError(404). The
// caller distinguishes "no result" from "request failed" via err.status.

import type { ApiClient } from "./client.js";
import type { SearchResponse, SuggestResponse } from "./types.js";

export function makeSearchApi(client: ApiClient) {
  return {
    /** Look up a subscriber by username / mobile / IP / MAC. */
    search(q: string): Promise<SearchResponse> {
      return client.get<SearchResponse>("/v1/api/search", { q });
    },
    /** Autocomplete: prefix/substring matches across username/mobile/router/switch/address. */
    suggest(q: string): Promise<SuggestResponse> {
      return client.get<SuggestResponse>("/v1/api/suggest", { q });
    },
  };
}

export type SearchApi = ReturnType<typeof makeSearchApi>;
